(() => {
  const currency = new Intl.NumberFormat('en-US', {
    style: 'currency', currency: 'USD', maximumFractionDigits: 0
  });

  function mount(root) {
    root.querySelectorAll('[data-bsfinance-calculator]').forEach(calculator => {
      if (calculator.dataset.bsFinanceReady === 'true') return;
      const field = name => calculator.querySelector(`[data-bsfinance-${name}]`);
      const model = field('model'), edition = field('edition'), delivery = field('delivery');
      const down = field('down'), term = field('term'), rate = field('rate-number');
      const slider = field('rate'), payment = field('payment'), principal = field('principal');
      const controls = [model, edition, delivery, down, term, rate];
      if (![...controls, payment, principal].every(Boolean)) return;
      calculator.dataset.bsFinanceReady = 'true';
      const result = calculator.querySelector('.bsfinance-result');
      if (result) {
        result.setAttribute('role', 'status');
        result.setAttribute('aria-live', 'polite');
        result.setAttribute('aria-atomic', 'true');
      }
      const label = slider && calculator.querySelector(`label[for="${slider.id}"]`);
      if (label && !rate.hasAttribute('aria-label')) rate.setAttribute('aria-label', label.textContent.trim());
      if (slider) {
        slider.min = rate.min || '0';
        slider.max = rate.max || '30';
        slider.step = rate.step || '0.1';
        slider.value = rate.value;
      }

      function update(event) {
        if (event?.target === slider) rate.value = slider.value;
        const values = controls.map(control => control.value.trim() === '' ? NaN : Number(control.value));
        const [base, upgrade, shipping, deposit, months, apr] = values;
        const valid = controls.map((control, index) => {
          const value = values[index];
          const okay = Number.isFinite(value) && value >= 0 &&
            !control.validity.badInput && !control.validity.rangeUnderflow && !control.validity.rangeOverflow &&
            (control !== term || (value > 0 && Number.isInteger(value)));
          control.setAttribute('aria-invalid', String(!okay));
          return okay;
        }).every(Boolean);
        if (!valid) {
          payment.textContent = '—';
          principal.textContent = '—';
          return;
        }
        if (slider) slider.value = rate.value;
        const amount = Math.max(0, base + upgrade + shipping - deposit);
        const monthlyRate = apr / 1200;
        const monthly = monthlyRate === 0 ? amount / months :
          amount * monthlyRate / -Math.expm1(-months * Math.log1p(monthlyRate));
        principal.textContent = currency.format(amount);
        payment.textContent = currency.format(monthly);
      }

      [...controls, slider].filter(Boolean).forEach(control => {
        control.addEventListener('input', update);
        control.addEventListener('change', update);
      });
      update();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => mount(document), {once: true});
  else mount(document);
  document.addEventListener('shopify:section:load', event => mount(event.target));
})();
